import { APIStatus } from "./APIStatus";

export class APIResponse<T>
{
    constructor(
        public status: APIStatus = APIStatus.ERROR,
        public message: string = "",
        public data: T | null = null
    ) { }
}